import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2-3.5l6-4.5-6-4.5z"
}), 'PlayCircleFilledWhiteOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlayCircleFilledWhiteOutlined.js
// module id = 5508
// module chunks = 2